// extracted by mini-css-extract-plugin
module.exports = {"arrow":"FreeGiftBanner_arrow__TyYqv","link":"FreeGiftBanner_link__4m7tu"};